import API from "../config/api.js";

export const ReportService = {
  // getRoleInfo(name) {
  //   return API.get(`api/role/info/${name}`);
  // },

  getUserAvailability(data) {
    return API.post(`api/employer/userAvailability`, data);
  },

  getCompletedProjectReport(search, page = 1) {
    return API.get(`api/projects/report/se=${search}?page=${page}`);
  },

  getProjectReport(search, page = 1) {
    return API.get(`api/projects/report1/se=${search}?page=${page}`);
  },

  getStockDetailsReport(filters = {}, page = 1) {
    return API.get("/api/report/binCardReport", {
      params: { ...filters, page },
    });
  },

  async getSalesReport({
    branch_id,
    start_date,
    end_date,
    type,
    product_id,
    category_id,
  }) {
    try {
      const response = await API.get(
        `/api/report/sales-report/${branch_id}/${start_date}/${end_date}/${type}/${product_id}/${category_id}`,
      );
      return response.data.data;
    } catch (error) {
      console.error("Error fetching sales report:", error);
      throw error;
    }
  },

  getDueCustomerReport(filters = {}) {
    return API.get("/api/report/due-customer-report", { params: filters });
  },

  getGrnItemsByProduct(params) {
    return API.get("/api/report/product-movement", {
      params,
    });
  },

  getTransactionReport(filters = {}, page = 1) {
    return API.get("/api/report/transactions", {
      params: { ...filters, page },
    });
  },
};
